import React, { useState, useEffect } from 'react';

export default function SellPropertyManagement({
  selectedTile,
  userId,
  onSellProperty,
  getTileUpgradeLevel,
  getEquipmentUpgradeLevel, // New prop
  getUpgradeCost,
  checkCanSellBank
}) {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [canSellBank, setCanSellBank] = useState(true);

  if (!selectedTile || !selectedTile.owner || selectedTile.owner.owner !== userId) {
    return null;
  }

  // Check if bank can be sold when component mounts or relevant data changes
  useEffect(() => {
    if (selectedTile.type === 13 && checkCanSellBank) {
      const canSell = checkCanSellBank(selectedTile.key);
      setCanSellBank(canSell);
    }
  }, [selectedTile, checkCanSellBank]);

  const calculateSellPrice = () => {
    const purchasePrice = selectedTile.owner.purchasePrice || 0;
    const upgradeLevel = getTileUpgradeLevel ? getTileUpgradeLevel(selectedTile.key) : 0;
    const equipmentLevel = getEquipmentUpgradeLevel ? getEquipmentUpgradeLevel(selectedTile.key) : 0;
    
    let totalUpgradeCost = 0;
    for (let level = 1; level <= upgradeLevel; level++) {
      totalUpgradeCost += getUpgradeCost ? getUpgradeCost(level) : 0;
    }
    
    let totalEquipmentCost = 0;
    for (let level = 1; level <= equipmentLevel; level++) {
      totalEquipmentCost += getUpgradeCost ? getUpgradeCost(level) : 0;
    }
    
    return (purchasePrice * 0.5) + (totalUpgradeCost * 0.5) + (totalEquipmentCost * 0.5);
  };

  const handleSellClick = () => {
    setShowConfirmation(true);
  };

  const handleConfirmSell = () => {
    onSellProperty(selectedTile.key);
    setShowConfirmation(false);
  };

  const handleCancelSell = () => {
    setShowConfirmation(false);
  };

  const sellPrice = calculateSellPrice();
  const upgradeLevel = getTileUpgradeLevel ? getTileUpgradeLevel(selectedTile.key) : 0;
  const equipmentLevel = getEquipmentUpgradeLevel ? getEquipmentUpgradeLevel(selectedTile.key) : 0;
  const isBank = selectedTile.type === 13;
  const canSell = !isBank || canSellBank;

  return (
    <div style={{
      marginBottom: '15px',
      padding: '10px',
      backgroundColor: 'rgba(255, 87, 34, 0.1)',
      borderRadius: '5px',
      border: '1px solid rgba(255, 87, 34, 0.3)'
    }}>
      <h5 style={{ margin: '0 0 10px 0', fontSize: '0.85em', color: '#FF5722', wordWrap: 'break-word' }}>
        💸 Sell Property
      </h5>
      
      <div style={{ fontSize: '0.75em', color: '#C8E6C9', marginBottom: '8px', wordWrap: 'break-word' }}>
        Sell this property and get back 50% of your investment:
      </div>

      {isBank && !canSellBank && (
        <div style={{ 
          fontSize: '0.7em', 
          color: '#FF9800', 
          marginBottom: '10px',
          padding: '5px',
          backgroundColor: 'rgba(255, 152, 0, 0.1)',
          borderRadius: '3px',
          border: '1px solid rgba(255, 152, 0, 0.3)',
          wordWrap: 'break-word'
        }}>
          ⚠️ Cannot sell bank: Must have no active deposits or loans
        </div>
      )}
      
      <div style={{ fontSize: '0.7em', color: 'rgba(255, 255, 255, 0.8)', marginBottom: '10px' }}>
        <div>Purchase Price: ${selectedTile.owner.purchasePrice?.toLocaleString() || '0'}</div>
        {upgradeLevel > 0 && (
          <div>Route Upgrade Investment: ${(() => {
            let total = 0;
            for (let level = 1; level <= upgradeLevel; level++) {
              total += getUpgradeCost ? getUpgradeCost(level) : 0;
            }
            return total.toLocaleString();
          })()}</div>
        )}
        {equipmentLevel > 0 && (
          <div>Equipment Upgrade Investment: ${(() => {
            let total = 0;
            for (let level = 1; level <= equipmentLevel; level++) {
              total += getUpgradeCost ? getUpgradeCost(level) : 0;
            }
            return total.toLocaleString();
          })()}</div>
        )}
        <div style={{ fontWeight: 'bold', color: '#90EE90', marginTop: '5px' }}>
          You'll receive: ${sellPrice.toLocaleString()}
        </div>
      </div>

      {!showConfirmation ? (
        <button
          onClick={handleSellClick}
          disabled={!canSell}
          style={{
            width: '100%',
            padding: '8px',
            backgroundColor: !canSell ? '#666' : '#FF5722',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: !canSell ? 'not-allowed' : 'pointer',
            fontSize: '0.8em',
            fontWeight: 'bold',
            opacity: !canSell ? 0.6 : 1
          }}
        >
          Sell Property
        </button>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '0.75em', 
            color: '#FFB74D', 
            marginBottom: '10px',
            fontWeight: 'bold',
            wordWrap: 'break-word'
          }}>
            ⚠️ Are you sure you want to sell this property? This action cannot be undone{isBank ? ' and will remove all bank settings' : ' and will remove all connections'}.
          </div>
          <div style={{ display: 'flex', gap: '5px' }}>
            <button
              onClick={handleConfirmSell}
              style={{
                flex: 1,
                padding: '6px',
                backgroundColor: '#F44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.75em',
                fontWeight: 'bold'
              }}
            >
              Yes, Sell
            </button>
            <button
              onClick={handleCancelSell}
              style={{
                flex: 1,
                padding: '6px',
                backgroundColor: '#4CAF50',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '0.75em',
                fontWeight: 'bold'
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
